import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Profile } from '../../../models/profile';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class ProfileService {

    public readonly DEFAULT_AVATAR = 'https://www.gravatar.com/avatar/170aa45eef0ef25aa2afdae742806c88?d=mp';

    private readonly CACHE_KEY = 'currentProfile';

    constructor(private http: HttpClient) {
    }

    /**
     * Load the current authenticated user's profile from /api/profile.
     * If useCache is true and a cached profile is available, return it immediately.
     */
    loadCurrentUser(useCache: boolean): Observable<Profile> {
        if (useCache) {
            const cached = this.openCachedProfile();
            if (cached) {
                return of(cached);
            }
        }
        return this.http.get<Profile>(`${environment.apiUrl}/profile`);
    }

    /**
     * Load a specific profile by username (for display/admin use only –
     * not for current-user bootstrap or authentication).
     */
    load(username: string): Observable<Profile> {
        return this.http.get<Profile>(`${environment.apiUrl}/profiles/${username}`);
    }

    openCachedProfile(): Profile | null {
        const stored = localStorage.getItem(this.CACHE_KEY);
        return stored ? JSON.parse(stored) : null;
    }

    /**
     * @deprecated Use openCachedProfile() for current-user profile.
     * This method is kept for components that look up profiles by username.
     */
    openProfile(username: string): Profile | null {
        const id = 'profile__' + username;
        const stored = localStorage.getItem(id);
        return stored ? JSON.parse(stored) : null;
    }

    storeProfile(profile: Profile): void {
        localStorage.setItem(this.CACHE_KEY, JSON.stringify(profile));
    }

    clearCachedProfile(): void {
        localStorage.removeItem(this.CACHE_KEY);
    }

    get guestProfileId(): string {
        return '_' + window.location.hostname.replace(/\./g, '_');
    }

}
